import { createSlice } from '@reduxjs/toolkit';
const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
const initialState = {
  email: storedUser.email || null,
  token: storedUser.token || null,
  id: storedUser.id || null,
};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.email = action.payload.email;
      state.token = action.payload.token;
      state.id = action.payload.id;
      localStorage.setItem('user', JSON.stringify(state));
    },
    removeUser(state) {
      state.email = null;
      state.token = null;
      state.id = null;
      localStorage.removeItem('user');
    },
  },
});
export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
